export const IconThreeCirclesMolecule = () => {
  return (
    <>
      <div className="block lg:hidden">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-full"
          viewBox="0 0 262 72"
        >
          <g
            id="Group_576"
            data-name="Group 576"
            transform="translate(-1196.5 -2747.903)"
          >
            <g
              id="Group_442"
              data-name="Group 442"
              transform="translate(1111.5 -1445.097)"
            >
              <text
                id="affordable"
                transform="translate(95.5 4233.5)"
                fill="#0032a0"
                className="font-waldo-sans text-xs font-normal text-center"
              >
                <tspan x="0" y="0">
                  affordable
                </tspan>
              </text>
              <g id="Group_444" data-name="Group 444">
                <g
                  id="Ellipse_37"
                  data-name="Ellipse 37"
                  transform="translate(85 4193)"
                  fill="none"
                  stroke="#0032a0"
                  strokeWidth="4"
                >
                  <circle cx="36" cy="36" r="36" stroke="none" />
                  <circle cx="36" cy="36" r="34" fill="none" />
                </g>
              </g>
            </g>
            <g
              id="Group_443"
              data-name="Group 443"
              transform="translate(1096.5 -1445.097)"
            >
              <text
                id="flexible"
                transform="translate(212 4233.5)"
                fill="#0032a0"
                className="font-waldo-sans text-xs font-normal text-center"
              >
                <tspan x="0" y="0">
                  flexible
                </tspan>
              </text>
              <g
                id="Ellipse_38"
                data-name="Ellipse 38"
                transform="translate(195 4193)"
                fill="none"
                stroke="#0032a0"
                strokeWidth="4"
              >
                <circle cx="36" cy="36" r="36" stroke="none" />
                <circle cx="36" cy="36" r="34" fill="none" />
              </g>
            </g>
            <g
              id="Group_499"
              data-name="Group 499"
              transform="translate(1139.5 -1251.597)"
            >
              <text
                id="long-term"
                transform="translate(259 4040)"
                fill="#0032a0"
                className="font-waldo-sans text-xs font-normal text-center"
              >
                <tspan x="0" y="0">
                  long-term
                </tspan>
              </text>
              <g
                id="Ellipse_38-2"
                data-name="Ellipse 38"
                transform="translate(247 3999.5)"
                fill="none"
                stroke="#0032a0"
                strokeWidth="4"
              >
                <circle cx="36" cy="36" r="36" stroke="none" />
                <circle cx="36" cy="36" r="34" fill="none" />
              </g>
            </g>
          </g>
        </svg>
      </div>
      <div className="hidden lg:block">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-full"
          viewBox="0 0 262 72"
        >
          <g
            id="Group_576"
            data-name="Group 576"
            transform="translate(-1196.5 -2747.903)"
          >
            <g
              id="Group_442"
              data-name="Group 442"
              transform="translate(1111.5 -1445.097)"
            >
              <text
                id="affordable"
                transform="translate(93 4233.5)"
                fill="#0032a0"
                className="font-waldo-sans text-xs font-normal text-center"
              >
                <tspan x="0" y="0">
                  affordable
                </tspan>
              </text>
              <g id="Group_444" data-name="Group 444">
                <g
                  id="Ellipse_37"
                  data-name="Ellipse 37"
                  transform="translate(85 4193)"
                  fill="none"
                  stroke="#0032a0"
                  strokeWidth="4"
                >
                  <circle cx="36" cy="36" r="36" stroke="none" />
                  <circle cx="36" cy="36" r="34" fill="none" />
                </g>
              </g>
            </g>
            <g
              id="Group_443"
              data-name="Group 443"
              transform="translate(1096.5 -1445.097)"
            >
              <text
                id="flexible"
                transform="translate(211 4233.5)"
                fill="#0032a0"
                className="font-waldo-sans text-xs font-normal text-center"
              >
                <tspan x="0" y="0">
                  flexible
                </tspan>
              </text>
              <g
                id="Ellipse_38"
                data-name="Ellipse 38"
                transform="translate(195 4193)"
                fill="none"
                stroke="#0032a0"
                strokeWidth="4"
              >
                <circle cx="36" cy="36" r="36" stroke="none" />
                <circle cx="36" cy="36" r="34" fill="none" />
              </g>
            </g>
            <g
              id="Group_499"
              data-name="Group 499"
              transform="translate(1139.5 -1251.597)"
            >
              <text
                id="long-term"
                transform="translate(257 4040)"
                fill="#0032a0"
                className="font-waldo-sans text-xs font-normal text-center"
              >
                <tspan x="0" y="0">
                  long-term
                </tspan>
              </text>
              <g
                id="Ellipse_38-2"
                data-name="Ellipse 38"
                transform="translate(247 3999.5)"
                fill="none"
                stroke="#0032a0"
                strokeWidth="4"
              >
                <circle cx="36" cy="36" r="36" stroke="none" />
                <circle cx="36" cy="36" r="34" fill="none" />
              </g>
            </g>
          </g>
        </svg>
      </div>
    </>
  );
};
